import { forwardRef } from "react";
import { ColumnConfig } from "../types";
import useLang from "Shared/hooks/useLanguage";

interface Props {
  columns: ColumnConfig[]; // prefix / exact columns (indexed lookups)
  columnId: number | null;
  value: string;
  onColumnChange: (id: number) => void;
  onValueChange: (value: string) => void;
  onApply: () => void;
  onClear: () => void;
}

// Identifier search (index seek). Applied on Enter, never per keystroke.
const QuickFind = forwardRef<HTMLInputElement, Props>(
  (
    { columns, columnId, value, onColumnChange, onValueChange, onApply, onClear },
    ref
  ) => {
    const { t } = useLang();
    if (!columns.length) return null;
    const current = columns.find((c) => c.id === columnId);

    return (
      <div className="vr2-quickfind d-flex gap-2">
        {columns.length > 1 && (
          <select
            className="form-select form-select-sm w-auto h-38px"
            aria-label={t("Search by")}
            value={columnId ?? ""}
            onChange={(e) => onColumnChange(Number(e.target.value))}
          >
            {columns.map((c) => (
              <option key={c.id} value={c.id}>
                {t(c.label)}
              </option>
            ))}
          </select>
        )}
        <div className="position-relative flex-grow-1">
          <i className="bi bi-search" aria-hidden="true"></i>
          <input
            ref={ref}
            id="ViewRequisitionV2QuickFind"
            className="form-control form-control-sm h-38px"
            placeholder={`${t("Find by")} ${t(current?.label ?? "identifier")} — ${t("press Enter")}`}
            autoComplete="off"
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") onApply();
              if (e.key === "Escape") {
                onClear();
                e.currentTarget.blur();
              }
            }}
          />
          <kbd>/</kbd>
        </div>
      </div>
    );
  }
);

QuickFind.displayName = "QuickFind";

export default QuickFind;
